import { Typography } from '@material-ui/core';
import { GREY_600, GREY_750 } from 'components/chatWidget/assets/theme/colors';
import { Col, Row } from 'components/chatWidget/common/Elements';
import React from 'react';
import { ReactComponent as CskhIcon } from '../../../assets/images/svg/ic_bg_cskh.svg';
import { ReactComponent as BgDotIcon } from '../../../assets/images/svg/ic_bg_dots.svg';

const ChatDinogo = (props) => {
  return (
    <>
      <Row style={{ width: '100%', justifyContent: 'space-around' }}>
        <Col
          style={{
            color: GREY_600,
            width: '50%',
          }}>
          <CskhIcon style={{ width: '100%', height: 600 }} />
          <Typography
            variant="h3"
            style={{ fontWeight: 400, color: GREY_750, textAlign: 'left' }}>
            Chat cùng Dinogo
          </Typography>
          <Typography
            variant="h3"
            style={{
              fontWeight: 700,
              color: GREY_750,
              textAlign: 'left',
              marginTop: 15,
            }}>
            Hỗ trợ khách hàng 24/7
          </Typography>
        </Col>
        <Col
          style={{ color: GREY_600, alignSelf: 'flex-start', marginTop: 44 }}>
          <BgDotIcon />
        </Col>
      </Row>
    </>
  );
};
export default ChatDinogo;
